var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('qrcode-vue',{attrs:{"value":_vm.url,"size":"150"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }